import React, { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'react-bootstrap'

import { isExcelFile } from 'helpers'
import * as fromActions from 'store/actions/monitoring.actions'
import { useTranslationRankmi } from 'helpers/translations.helper'
import UploadFile from 'components/ui/modals/UploadFile'
import { IMainState } from 'store/states'

interface UploadButtonProps {
  className?: string
  refetchCourseUsers?: () => void
  disabled?: boolean
}

const UploadButton: React.FC<UploadButtonProps> = ({
  className,
  refetchCourseUsers,
  disabled,
}) => {
  const [error, setError] = React.useState<React.ReactNode>(null)
  const { t } = useTranslation()
  const tUpload = useTranslationRankmi({
    prefix: 'administration.monitor.upload',
  })
  const dispatch = useDispatch()
  const course = useSelector(({ courses }: IMainState) => courses.course)

  const [show, setShow] = useState(false)
  const handleClose = () => {
    setShow(false)
    setError(null)
  }

  const handleShow = () => setShow(true)

  const handleFileUpload = (file: File) => {
    setError(null)
    if (!isExcelFile(file)) {
      setTimeout(() => {
        setError(<>{tUpload('modal.error')}</>)
      }, 500)
      return
    }
    if (course.id)
      dispatch(
        fromActions.Actions.uploadFile({
          id: course.id,
          file,
          onSuccess: refetchCourseUsers,
        })
      )
    setShow(false)
  }

  const isSynchronousCourse = !!course.synchronousCourse?.id

  const link = useMemo(() => {
    if (isSynchronousCourse)
      return 'https://rankmi-lms-prod.s3.amazonaws.com/templates/participants.xlsx'
    return 'https://rankmi-lms-prod.s3.amazonaws.com/templates/import_participants.xlsx'
  }, [isSynchronousCourse])

  return (
    <>
      <Dropdown.Item
        className={className}
        onClick={handleShow}
        disabled={disabled}
      >
        {tUpload('label')}
      </Dropdown.Item>
      <UploadFile
        show={show}
        title={tUpload('modal.title')}
        labels={{
          legend: tUpload('modal.legend'),
          addFile: tUpload('modal.addFile'),
          close: t('commons.buttons.close'),
        }}
        template={{
          link,
          label: tUpload('modal.template'),
        }}
        onClose={() => {
          handleClose()
        }}
        onUpload={handleFileUpload}
        error={error}
      />
    </>
  )
}

export default UploadButton
